import { DocumentType } from '../document-type/DocumentType'

export enum AlfredDocumentTypeId {
  INVOICE = 1,
  RECEIPT = 2,
  PROFORMA = 3,
  ADVANCE_PAYMENT_DOCUMENT = 4,
  PROFORMA_WITH_ADVANCE_PAYMENT_DOCUMENT = 999,
}

export class AlfredDocumentType {
  static readonly RECEIPT = new AlfredDocumentType(AlfredDocumentTypeId.RECEIPT, () =>
    DocumentType.RECEIPT.label(),
  )
  static readonly INVOICE = new AlfredDocumentType(AlfredDocumentTypeId.INVOICE, () =>
    DocumentType.INVOICE.label(),
  )
  static readonly ADVANCE_PAYMENT_DOCUMENT = new AlfredDocumentType(
    AlfredDocumentTypeId.ADVANCE_PAYMENT_DOCUMENT,
    () => DocumentType.ADVANCE_PAYMENT_DOCUMENT.label(),
  )
  static readonly PROFORMA = new AlfredDocumentType(AlfredDocumentTypeId.PROFORMA, () =>
    DocumentType.PROFORMA.label(),
  )
  static readonly PROFORMA_WITH_APD = new AlfredDocumentType(
    AlfredDocumentTypeId.PROFORMA_WITH_ADVANCE_PAYMENT_DOCUMENT,
    () => `${DocumentType.PROFORMA.label()} + ${DocumentType.ADVANCE_PAYMENT_DOCUMENT.label()}`,
  )

  private constructor(
    public readonly id: AlfredDocumentTypeId,
    public readonly label: () => string,
  ) {}

  static all = (): AlfredDocumentType[] => {
    return [
      AlfredDocumentType.RECEIPT,
      AlfredDocumentType.INVOICE,
      AlfredDocumentType.ADVANCE_PAYMENT_DOCUMENT,
      AlfredDocumentType.PROFORMA_WITH_APD,
      AlfredDocumentType.PROFORMA,
    ]
  }
}
